import React from "react";
import "./Divider.css";

export default function Divider({ className, ...props }) {
    return <div className={`divider ${className}`}>{props.children}</div>;
}
